import React from 'react'
import PropTypes from 'prop-types'
import {
  IconFAWrapper,
  ICON_FA_VARIANT_SOLID,
  ICON_FA_VARIANT_REGULAR,
  ICON_FA_VARIANT_LIGHT
} from './IconFAWrapper'

export const IconFAChevronDown = ({
  className,
  variant,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconFAWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      {variant === ICON_FA_VARIANT_SOLID ? (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='fas'
          data-icon='chevron-down'
          role='img'
          viewBox='0 0 448 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z'
          />
        </svg>
      ) : variant === ICON_FA_VARIANT_REGULAR ? (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='far'
          data-icon='chevron-down'
          role='img'
          viewBox='0 0 448 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z'
          />
        </svg>
      ) : (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='fal'
          data-icon='chevron-down'
          role='img'
          viewBox='0 0 448 512'
        >
          <path
            fill='currentColor'
            d='M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z'
          />
        </svg>
      )}
    </IconFAWrapper>
  )
}

IconFAChevronDown.defaultProps = {
  variant: ICON_FA_VARIANT_REGULAR
}

IconFAChevronDown.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    ICON_FA_VARIANT_SOLID,
    ICON_FA_VARIANT_REGULAR,
    ICON_FA_VARIANT_LIGHT
  ]),
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
